import { Helmet } from "react-helmet";
import {
    Box,
    Tab,
    Tabs,
    Container,
    Grid,
    Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useMemo } from "react";
import cssVariables from "../../../../theme/cssVariables";
import RolePermission from "./RolePermission";
import { useSelector, useDispatch } from "react-redux";
import UserResetPassword from "./UserResetPassword";
import securityService from "../../../../services/security.service";
import * as Util from "../../../../services/global.service";

const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const Securitys = () => {
    const useStyles = makeStyles({
        select: {
            '& div ': {
                padding: "8.5px 8.5px 8.5px 15px"
            },
        },
        dateTimePicker: {
            display: "flex !important",
            flexDirection: "column !important",
            justifyContent: "space-between !important",
            position: "relative",
            marginBottom: "14px !important",

        },
        plusSvg: {
            "& > path": {
                fill: "#fff",
                stroke: "#fff",
            },
        },
        input: {
            '& div > input': {
                height: '7px',
                position: "relative"
            }
        },
        draggingListItem: {
            background: 'rgb(235,235,235)'
        },
        toggleBtnRoot: {
            background: `transparent !important`,
            color: "#6B6B6B !important",
            width: "320px",
            border: "none !important",
        },
        toggleBtnSelected: {
            background: `${cssVariables.color.primary}!important`,
            color: "#fff!important",
        },
        flexPaper: {
            flex: 1,
            minWidth: 350,
            "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
            "border-radius": "10px !important        "
        },
        tab: {
            "text-transform": "none !important",
            fontSize: "16px !important",
            fontWeight: "400 !important",
            color: "#A3A3A3 !important",
            '&.Mui-selected': {
                color: cssVariables.color.primary + " !important"
            }
        },
        root: {
            display: 'flex',
            width: "100%",
            flexWrap: 'wrap'
        }
    })
    const [mainItems, setMainItems] = React.useState([]);
    const [mainItemsRolePermission, setMainItemsRolePermission] = React.useState([]);
    let { serial } = useParams()
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [value, setValue] = React.useState('users');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    let getList = () => {
        securityService.listUser().then(
            (response) => {
                setMainItems(response.data.permission_user);
            },
        )
        securityService.listRolePermission().then(
            (response) => {
                setMainItemsRolePermission(Util.formatData(response?.data?.permission_role, []))
            },
        )
    }
    useEffect(() => {
        getList()
    }, []);

    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const [isCollapse, setIsCollapse] = React.useState(false);
    const onScroll = () => {
        if (isCollapse) {
            setIsCollapse(false)
        }
    }

    return (
        <Box onScroll={onScroll} style={{ "max-height": "100%", "overflow-y": "auto" }}>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.end} >{t('security.security')}</span></Typography>
                    </Grid>
                    <Grid container item >
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} pt="7px" pb="13px">
                            <Typography variant="h2" color="#404349" fontSize={36} lineHeight="40px" >
                                {t('security.security')}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid container >
                        <Grid container item sx={{ height: "100%" }}>
                            <Box sx={{ width: "100%" }}>
                                <Tabs
                                    value={value}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    onChange={handleChange}
                                    TabIndicatorProps={{
                                        style: {
                                            height: "8px",
                                        },
                                    }}
                                >
                                    <Tab label={t('security.users')} value={`users`} classes={{ root: classes.tab }} />
                                    <Tab label={t('security.rolePermission')} value={`rolePermission`} classes={{ root: classes.tab }} />
                                </Tabs>
                            </Box>
                            {/* // ใส่ตรงนี้ */}
                            {value === 'rolePermission' ?
                                <RolePermission mainItems={mainItemsRolePermission} getList={getList}/>
                                :
                                null
                            }
                            {value === 'users' ?
                                <UserResetPassword mainItems={mainItems} />
                                :
                                null
                            }
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </Box>
    );
};
export default Securitys;
